import React from 'react'
import { DraftTabs } from '../DraftTabs'
import {
  BasicAccordion,
  AccordionHeader,
} from '../../../Components/Layout/Accordion'
import { Head2 } from '../../../Components/Typography/Text.styles'
import { prevDraftYearsList } from '../../../Config/League/league.config'
import { Box } from '../../../Components/Layout'

export const PrevDraftCon: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Box>
      <Head2>Previous Drafts</Head2>
      <BasicAccordion
        defaultPanel={0}
        accordionItems={prevDraftYearsList.map((year) => {
          return {
            headerComponent: <AccordionHeader label={`${year}`} subText={``} size='small' key={year} />,
            summaryComponent: <DraftTabs year={year} key={year} />
          }
        })}
      />
    </Box>
  )
}